import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ThemeProvider } from 'next-themes';
import { BrowserRouter } from 'react-router-dom';
import { useEffect, type ReactNode } from 'react';
import { AuthProvider, useAuth } from '@/features/auth';
import { I18nProvider, isLocale, useI18n } from '@/shared/i18n';
import { Toaster } from '@/shared/ui/shadcn/sonner';
import { TooltipProvider } from '@/shared/ui/shadcn/tooltip';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

function SyncAccountLocale() {
  const { user } = useAuth();
  const { setLocale } = useI18n();
  useEffect(() => {
    if (isLocale(user?.locale)) setLocale(user.locale);
  }, [setLocale, user?.locale]);
  return null;
}

export function AppProviders({ children }: { children: ReactNode }) {
  return (
    <ThemeProvider attribute="class" defaultTheme="system" enableSystem disableTransitionOnChange>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <I18nProvider>
            <AuthProvider>
              <SyncAccountLocale />
              <TooltipProvider>
                {children}
                <Toaster richColors closeButton />
              </TooltipProvider>
            </AuthProvider>
          </I18nProvider>
        </BrowserRouter>
      </QueryClientProvider>
    </ThemeProvider>
  );
}
